import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import { MessageService, SelectItem } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { ChipModule } from 'primeng/chip';
import { TableModule } from 'primeng/table';
import { Condition, CustomTitle, FormCreatorService, ICondition, IToken, Operator, TypeChecker } from 'lib-base';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-condition-builder',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule, TranslateModule,
    DialogModule, ButtonModule, DropdownModule, ToastModule, InputTextModule, TableModule, ChipModule,
    CustomTitle
  ],  
  templateUrl: './condition-builder.component.html',
  styleUrls: ['./condition-builder.component.scss']
})
export class ConditionBuilderComponent implements OnInit {
  @Input() fieldId !: string;
  @Input() existingTokens: IToken[] = [];
  @Output() onApplyConditions = new EventEmitter<IToken[]>();
  @ViewChild('conditionsForm') conditionsForm!: NgForm;

  displayModal: boolean = false;
  tokens: IToken[] = [];

  operatorList: Operator[];
  variableList: string[]
  conditionList !: { [key: string]: ICondition[]};

  get Control() {
    return this.fc.ConfigurationSection.control;
  }

  get currentTokens(){
    return this.existingTokens;
  }

  constructor(private fc: FormCreatorService, private messageService: MessageService) {
    this.operatorList = ['and', 'or'];
    this.variableList = []    
  }

  ngOnInit(): void {
    this.tokens = JSON.parse(JSON.stringify(this.existingTokens));
  }

  openModal() {
    this.displayModal = true;
    this.InitializeConditions();
  }

  closeModal() {
    this.tokens = this.existingTokens;
    this.displayModal = false;
  }

  InitializeConditions() {
    this.tokens = [];
    if (this.Control && TypeChecker.hasProperty(this.Control, this.fieldId)) {
      this.variableList = this.fc.Form.getControlNames(this.Control?.name);
      if (this.Control[this.fieldId].length === 0) {
        this.tokens = [];
        this.addToken();
      } else {
        this.tokens = JSON.parse(JSON.stringify(this.existingTokens));
      }
    }

  }

  getConditionList(controlName: string): ICondition[] {
    const control = this.fc.Form.findControlByName(controlName);
    return control ? control.conditionList : [];
  }

  onVariableChange(item: IToken) {
    const control = this.fc.Form.findControlByName(item.controlName);
    this.conditionList = control ? { [item.controlName]: control.conditionList } : {};
  }

  addToken(): void {
    const newToken: IToken = {
      controlName: '',
      condition: Condition.NotEmpty,
      value: '',
      operator: 'and'
    };

    this.tokens.push(newToken);
  }

  removeToken(index: number) {
    this.tokens.splice(index, 1);
  }

  onSubmitConditions() {
    if (this.conditionsForm.valid) {
      this.onApplyConditions.emit(this.tokens);
      this.displayModal = false;
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'All fields must be selected' });
    }
  }

  getConditionText(controlName: string, condition: string): string {
    return this.getConditionList(controlName)?.find(c => c.value === condition)?.label ?? '';
  }
}
